// AES加密 mode:ECB, pad: Pkcs7
const CryptoJS = require('crypto-js');  //引用AES源码js

const key = CryptoJS.enc.Utf8.parse("i7eSPiEXZqyLjt2PGYxZi4hESP8mIlep"); //密钥
const iv = CryptoJS.enc.Utf8.parse('EJ9iIPhzB4I5UDfv'); //密钥偏移量

/**
 * 加密
 * @param word
 * @returns {*}
 */
export function Encrypt(word){
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {iv, mode:CryptoJS.mode.CBC,padding: CryptoJS.pad.Pkcs7});
  return encrypted.toString();
}

/**
* 解密
* @param word
* @returns {*}
*/
export function Decrypt(word){
  var decrypt = CryptoJS.AES.decrypt(word, key, {iv, mode:CryptoJS.mode.CBC,padding: CryptoJS.pad.Pkcs7});
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}